import { render, staticRenderFns } from "./salesReturnsEdit_ec.vue?vue&type=template&id=0195c5e8&scoped=true&"
import script from "./salesReturnsEdit_ec.vue?vue&type=script&lang=js&"
export * from "./salesReturnsEdit_ec.vue?vue&type=script&lang=js&"
import style0 from "./salesReturnsEdit_ec.vue?vue&type=style&index=0&id=0195c5e8&lang=less&scoped=true&"
import style1 from "./salesReturnsEdit_ec.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0195c5e8",
  null
  
)

component.options.__file = "salesReturnsEdit_ec.vue"
export default component.exports